import { api } from "@api/api";
import { PartnerSummary } from "@modules/partners/types";

export async function getPartnerSummaryService(): Promise<PartnerSummary> {
  const { data } = await api.get<PartnerSummary>("/v1/partner_summary_admin/");
  return data;
}
